module.exports = __webpack_public_path__ + "img/hikvision_logo_svg.6299403a.svg";